export const HOST = process.env.REACT_APP_API_HOST;
export const API = "/gfapp";
